import * as THREE from 'three';
import PRNG from './PRNG';

export default class CrucibleColors {
  protected _mainHues: number[];
  protected _prng: PRNG | null;

  constructor() {
    this._mainHues = [];
    this._prng = null;
  }

  setup(prng: PRNG) {
    this._mainHues = [];
    this._prng = prng;

    let hueCount = 4 + prng.randomInt('colors', 6);

    while (hueCount) {
      hueCount--;
      this._mainHues.push(240 + prng.randomInt('colors', 20));
      this._mainHues.push(160 + prng.randomInt('colors', 30));
      this._mainHues.push(0 + prng.randomInt('colors', 50));
    }
  }

  getHSLColor() {
    if (this._prng === null) throw Error;

    const h = Math.floor(160 + this._prng.randomInt('colors', 160));
    const s = Math.floor(
      40 + 2 * Math.min(this._prng.randomInt('colors', 100), 100)
    );
    const l = Math.floor(
      2 + 1.5 * Math.min(this._prng.randomInt('colors', 10), 30)
    );

    const hslColor = 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
    return hslColor;
  }

  getTHREEColor() {
    if (this._prng === null) throw Error;

    const hueJitter = Math.floor(10 * (0.5 - this._prng.randomFloat('colors')));
    const hueBase =
      this._mainHues[this._prng.randomInt('colors', this._mainHues.length)];
    const saturation = Math.floor(50 + this._prng.randomInt('colors', 35));
    const lightness = Math.floor(20 + this._prng.randomInt('colors', 50));

    const color = `hsl(${hueBase + hueJitter}, ${saturation}%, ${lightness}%)`;
    return new THREE.Color(color);
  }

  getHue() {
    if (this._prng === null) throw Error;
    return this._mainHues[
      this._prng.randomInt('colors', this._mainHues.length)
    ];
  }

  getHueJitter() {
    if (this._prng === null) throw Error;
    return Math.min(this._prng.randomInt('colors', 40), 40);
  }

  getSaturationJitter() {
    if (this._prng === null) throw Error;
    return Math.min(this._prng.randomInt('colors', 20), 20);
  }

  getLightnessJitter() {
    if (this._prng === null) throw Error;
    return Math.min(this._prng.randomInt('colors', 25), 25);
  }
}
